/* Keep Swym's restock UI out of the layout for purchasable variants. */
(() => {
  const marker = 'data-bh-swym-collapsed';
  const candidates = '.swym-isa-button-bar, [class*="swym"], [id*="swym"]';
  let queued = false;

  function isRestock(element) {
    const identity = `${element.id} ${element.className}`;
    return /swym/i.test(identity) && /(?:isa|bis|back.?in.?stock|watchlist|restock)/i.test(identity);
  }

  function sync() {
    queued = false;
    const main = document.querySelector('main');
    if (!main) return;
    for (const form of main.querySelectorAll('product-form-component[data-product-id]')) {
      if (form.closest('dialog, quick-add-dialog, product-card')) continue;
      const section = form.closest('.shopify-section');
      if (!section) continue;
      const picker = [...section.querySelectorAll('variant-picker')].find(p =>
        !p.dataset.productId || p.dataset.productId === form.dataset.productId);
      let variant;
      try { variant = JSON.parse(picker?.querySelector('script[type="application/json"]')?.textContent || 'null'); } catch {}
      const selectedId = form.querySelector('input[name="id"]')?.value;
      if (!variant || String(variant.id) !== selectedId) {
        const data = document.querySelector('#bh-swym-variants');
        if (data?.dataset.productId === form.dataset.productId) {
          try { variant = JSON.parse(data.textContent).find(v => String(v.id) === selectedId); } catch {}
        }
      }
      // Fail open during unresolved selections; never infer sold out from a disabled button.
      const available = variant && String(variant.id) === selectedId && variant.available === true;
      for (const element of section.querySelectorAll(`[${marker}]`)) {
        if (!available) element.removeAttribute(marker);
      }
      if (!available) continue;
      for (const element of section.querySelectorAll(candidates)) {
        if (!isRestock(element) || element.closest('dialog, [role="dialog"], product-card, bh-complete-look')) continue;
        // Include a Swym-only outer wrapper so its margin/flex gap disappears too.
        let wrapper = element;
        while (wrapper.parentElement !== section && /swym/i.test(`${wrapper.parentElement?.id} ${wrapper.parentElement?.className}`)) {
          wrapper = wrapper.parentElement;
        }
        if (!wrapper.hasAttribute(marker)) wrapper.setAttribute(marker, '');
      }
    }
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(sync);
  }
  const observer = new MutationObserver(schedule);
  function init() {
    observer.observe(document.querySelector('main') || document.body, {
      subtree: true, childList: true, characterData: true, attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'value', 'disabled']
    });
    document.addEventListener('change', schedule);
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('shopify:product:select', schedule);
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
